import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import AcademicYearViewModel from '../ViewModels/AcademicYearViewModel';
import { SelectValidator } from 'react-material-ui-form-validator';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IAcademicYearDropDownProps {
    setAcademicYearId?: (event) => void;
    academicYear: string | undefined;
    disabled: boolean;
    fromYear: number;
    toYear: number;
    documentUploadMode: boolean;
}

interface IAcademicYearDropDownState {
    model: AcademicYearViewModel[];
    loaded: boolean;
}

class AcademicYearDropDown extends Component<IAcademicYearDropDownProps & WithStyles<typeof styles>, IAcademicYearDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        if (this.props.documentUploadMode === false) {
            fetch('api/DropDown/GetAcademicYears')
                .then(response => response.json()).then((data) => {
                    this.setState({
                        model: data,
                        loaded: true,
                    });
                });
        } else {
            fetch('api/DropDown/GetDocumentUploadAcademicYears')
                .then(response => response.json()).then((data) => {
                    this.setState({
                        model: data,
                        loaded: true,
                    });
                });
        }
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultAcademicYearVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="Academic Year"
                name="academicYearId"
                title="Academic Year"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.academicYear === undefined ? '' : this.props.academicYear}
                onChange={this.props.disabled ? undefined : this.props.setAcademicYearId}
                disabled={this.props.disabled}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(AcademicYearDropDown);